import { Button, Map16 } from '@cian/ui-kit';
import React from 'react';

import * as styles from './MapBanner.css';
interface IMapBannerProps {
  url: string;
  onClick(e: React.SyntheticEvent<HTMLAnchorElement>): void;
}

export function MapBanner({ url, onClick }: IMapBannerProps) {
  return (
    <a href={url} target="_blank" onClick={onClick} className={styles['map-banner']} rel="noreferrer">
      <Button fullWidth beforeIcon={<Map16 color="current_color" />} theme="fill_white_primary">
        Смотреть на карте
      </Button>
    </a>
  );
}
